import { render, staticRenderFns } from "./BidSummary.vue?vue&type=template&id=3b057888&"
import script from "./BidSummary.vue?vue&type=script&lang=js&"
export * from "./BidSummary.vue?vue&type=script&lang=js&"
import style0 from "./BidSummary.vue?vue&type=style&index=0&id=3b057888&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports